export default "__VITE_ASSET__634d9fed__"